import http from "./http";

//获取官网
export function get_official_api() {
  return new Promise((resolve, reject) => {
    http.get("/homepage/textfile").then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//官网创建
export function add_official_api(data = {}) {
  return new Promise((resolve, reject) => {
    http.post("/homepage/textfile", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//修改
export function edit_official_api(id , data = {}) {
  return new Promise((resolve, reject) => {
    http.put("/homepage/textfile?id=" + id , data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//删除
export function delete_official_api(id) {
  return new Promise((resolve, reject) => {
    http.delete("/homepage/textfile?id=" + id).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
